var _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKustoLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 800,
    height: 800,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "file_type_kusto") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "a"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: "100%",
    height: "100%",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 16.226,
    y: 9.001,
    width: 2.796,
    height: 2.796,
    rx: 0.622,
    transform: "rotate(-44.999 17.623 10.4)",
    style: {
      fill: "#000"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20.18,
    y: 5.048,
    width: 2.796,
    height: 2.796,
    rx: 0.622,
    transform: "rotate(-44.999 21.579 6.446)",
    style: {
      fill: "#000"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20.18,
    y: 12.955,
    width: 2.796,
    height: 2.796,
    rx: 0.622,
    transform: "rotate(-44.999 21.578 14.353)",
    style: {
      fill: "#000"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24.133,
    y: 9.002,
    width: 2.796,
    height: 2.796,
    rx: 0.622,
    transform: "rotate(-44.999 25.531 10.4)",
    style: {
      fill: "#000"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 0.55,
    y: 22.339,
    width: 15.433,
    height: 2.796,
    rx: 0.439,
    transform: "rotate(-44.999 8.266 23.737)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.372,
    y: 16.382,
    width: 9.859,
    height: 2.796,
    rx: 0.439,
    transform: "rotate(-44.999 6.301 17.78)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9.232,
    y: 24.301,
    width: 9.859,
    height: 2.796,
    rx: 0.439,
    transform: "rotate(-44.999 14.162 25.7)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff"
    },
    d: "M30 2H2l28 27.999z",
    mask: "url(#a)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff"
    },
    d: "m10.282 10.282 11.436 11.436L30 13.436V2H18.564z",
    mask: "url(#a)"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKustoLogo);
export default __webpack_public_path__ + "static/media/Kusto_Logo.960f853ee01831f1fb15229a2dbeccda.svg";
export { ForwardRef as ReactComponent };